// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
  overflow-x: visible;
}

.dashboard-container h1 {
  margin-bottom: 20px;
  color: #333;
}

.dashboard-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: visible;
  gap: 20px;
}

.jobs-list {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 0;
  overflow: hidden;
}

.jobs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  border-bottom: 1px solid #e9ecef;
  background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
}

.jobs-header h2 {
  margin: 0;
  color: #2c3e50;
  font-size: 1.5rem;
  font-weight: 600;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.auto-refresh-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background: rgba(74, 144, 226, 0.1);
  border-radius: 8px;
  border: 1px solid rgba(74, 144, 226, 0.2);
}

.auto-refresh-controls label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #4a90e2;
  font-weight: 500;
}

.refresh-interval {
  display: flex;
  align-items: center;
  gap: 6px;
}

.refresh-interval input {
  width: 60px;
  padding: 4px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
}

.refresh-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(74, 144, 226, 0.3);
}

.refresh-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.4);
}

.refresh-icon {
  animation: rotate 2s linear infinite paused;
}

.refresh-btn:hover .refresh-icon {
  animation-play-state: running;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.search-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 32px;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
}

.search-wrapper {
  position: relative;
  flex: 1 1;
  max-width: 500px;
}

.search-input {
  width: 100%;
  padding: 12px 20px;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  font-size: 14px;
  outline: none;
  transition: all 0.2s ease;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.search-input:focus {
  border-color: #4a90e2;
  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
}

.search-input::placeholder {
  color: #6c757d;
}

.clear-search-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  font-size: 16px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.clear-search-btn:hover {
  background-color: #f8f9fa;
  color: #495057;
}

.job-count-info {
  font-size: 14px;
  color: #6c757d;
  font-weight: 500;
  padding: 8px 16px;
  background: white;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

/* Table Container */
.jobs-table-container {
  border-radius: 0 0 12px 12px;
}

.table-wrapper {
  width: 100%;
}

.modern-jobs-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  table-layout: fixed;
}

.modern-jobs-table th {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  color: #495057;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 12px 16px;
  text-align: left;
  border-bottom: 2px solid #dee2e6;
  position: sticky;
  top: 0;
  z-index: 10;
}

.modern-jobs-table th:first-child {
  padding-left: 32px;
}

.modern-jobs-table th:last-child {
  padding-right: 32px;
}

/* Column widths - Updated for 6 columns */
.col-video-id { width: 260px; }
.col-file-name { width: 300px; }
.col-user { width: 180px; }
.col-status { width: 60px; }
.col-created { width: 160px; }
.col-actions { width: 120px; }

.job-row {
  transition: all 0.2s ease;
  cursor: pointer;
  border-bottom: 1px solid #f1f3f4;
}

.job-row:hover {
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.job-row.expanded {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-bottom: 2px solid #2196f3;
}

.job-row td {
  padding: 12px 16px;
  vertical-align: middle;
  border-bottom: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.job-row td:first-child {
  padding-left: 32px;
}

.job-row td:last-child {
  padding-right: 32px;
}

/* Cell Styles */
.job-id-badge {
  display: inline-block;
  padding: 6px 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  min-width: 40px;
  text-align: center;
}

.video-id-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.video-id-text {
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 12px;
  color: #2c3e50;
  background: #f8f9fa;
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.copy-btn {
  background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);
  color: white;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
  font-size: 11px;
  font-weight: 500;
  flex-shrink: 0;
  white-space: nowrap;
}

.copy-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(74, 144, 226, 0.3);
}

.file-info {
  display: flex;
  align-items: center;
  width: 100%;
}

.file-details {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
}

.filename {
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 12px;
  color: #2c3e50;
  background: linear-gradient(135deg, #e8f5e8 0%, #f0fff0 100%);
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #c3e6c3;
  display: block;
  margin-bottom: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-source {
  font-size: 10px;
  color: #6c757d;
  font-style: italic;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.user-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #e9ecef;
  object-fit: cover;
  flex-shrink: 0;
}

.user-details {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
}

.user-name {
  font-weight: 500;
  color: #2c3e50;
  font-size: 13px;
  margin-bottom: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-email {
  font-size: 11px;
  color: #6c757d;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-badge.modern {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: 1px solid transparent;
}

.status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

.status-completed .status-indicator {
  background: #28a745;
  animation: none;
}

.status-completed {
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  color: #155724;
  border-color: #c3e6cb;
}

.status-processing .status-indicator {
  background: #fd7e14;
}

.status-processing {
  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
  color: #856404;
  border-color: #ffeaa7;
}

.status-pending .status-indicator {
  background: #6f42c1;
}

.status-pending {
  background: linear-gradient(135deg, #e2e3f0 0%, #d1ecf1 100%);
  color: #6f42c1;
  border-color: #d1ecf1;
}

.status-failed .status-indicator {
  background: #dc3545;
  animation: none;
}

.status-failed {
  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
  color: #721c24;
  border-color: #f5c6cb;
}

/* Status indicator only (color circle) styles */
.status-indicator-only {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.2s ease;
}

.status-indicator-only:hover {
  transform: scale(1.2);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.status-indicator-only.status-completed {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border-color: #28a745;
}

.status-indicator-only.status-processing {
  background: linear-gradient(135deg, #ffc107 0%, #fd7e14 100%);
  border-color: #ffc107;
  animation: pulse 2s infinite;
}

.status-indicator-only.status-pending {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  border-color: #6c757d;
}

.status-indicator-only.status-failed {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  border-color: #dc3545;
}

/* Open App Button */
.open-app-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.2);
}

.open-app-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
  background: linear-gradient(135deg, #218838 0%, #1e7e34 100%);
}

.date-cell {
  text-align: left;
}

.date-primary {
  font-size: 13px;
  color: #2c3e50;
  font-weight: 500;
  margin-bottom: 2px;
}

.date-secondary {
  font-size: 11px;
  color: #6c757d;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
}

.action-buttons {
  display: flex;
  gap: 6px;
  justify-content: center;
}

.action-btn {
  background: none;
  border: 1px solid #e9ecef;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s ease;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-btn:hover {
  background: #f8f9fa;
  border-color: #dee2e6;
  transform: scale(1.1);
}

.view-btn:hover {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-color: #2196f3;
}

.expand-btn:hover {
  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
  border-color: #ff9800;
}

.no-data {
  color: #6c757d;
  font-style: italic;
  font-size: 13px;
}

/* Empty States */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #6c757d;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-title {
  font-size: 18px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
}

.empty-subtitle {
  font-size: 14px;
  margin-bottom: 20px;
}

.clear-search-link {
  background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.clear-search-link:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(74, 144, 226, 0.3);
}

/* Expanded Row */
.expanded-row td {
  padding: 0;
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
  border-bottom: 2px solid #2196f3;
}

.expanded-cell {
  animation: expandRow 0.3s ease-out;
}

@keyframes expandRow {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.expanded-content {
  padding: 32px;
  border-left: 4px solid #2196f3;
  margin: 0 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.expanded-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e9ecef;
}

.expanded-header h3 {
  margin: 0;
  font-size: 1.3rem;
  color: #2c3e50;
  font-weight: 600;
}

.close-button {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.close-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);
}

/* Responsive Design */
@media (max-width: 1200px) {
  .col-created, .col-updated {
    display: none;
  }
  
  .jobs-header {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
  
  .search-controls {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
}

@media (max-width: 768px) {
  .col-file-name, .col-user {
    display: none;
  }
  
  .jobs-header,
  .search-controls {
    padding: 16px 20px;
  }
  
  .job-row td:first-child,
  .modern-jobs-table th:first-child {
    padding-left: 20px;
  }
  
  .job-row td:last-child,
  .modern-jobs-table th:last-child {
    padding-right: 20px;
  }
  
  .expanded-content {
    padding: 20px;
    margin: 0 10px;
  }
}

/* Copy Toast Notification */
.copy-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  z-index: 10000;
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.copy-toast.visible {
  opacity: 1;
  transform: translateY(0);
}

/* Reel Format Video Styles */
.reel-format {
  margin-bottom: 32px;
}

.reel-video-container {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  aspect-ratio: 9/16; /* Fixed aspect ratio for reel format */
}

.reel-video-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.reel-video {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  background: #000;
  display: block;
}

.original-video-section.reel-format h4,
.clip-preview-section.reel-format h4 {
  text-align: center;
  margin-bottom: 20px;
  padding: 16px 24px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.original-download-btn,
.clip-download-btn {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.original-download-btn:hover,
.clip-download-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
}

.original-download-btn:disabled,
.clip-download-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.close-preview-btn {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.close-preview-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);
}

/* Video loading state for reel format */
.reel-video-wrapper .video-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
}

/* Responsive design for reel format */
@media (max-width: 768px) {
  .reel-video-container {
    max-width: 100%;
    margin: 0 16px;
    aspect-ratio: 9/16; /* Maintain aspect ratio on mobile */
  }
  
  .reel-video-wrapper {
    width: 100%;
    height: 100%;
  }
  
  .original-video-section.reel-format h4,
  .clip-preview-section.reel-format h4 {
    flex-direction: column;
    gap: 12px;
    padding: 12px 16px;
  }
}

/* Clip thumbnail reel format */
.video-preview.reel-format .reel-video-container {
  max-width: 200px;
  width: 200px;
  aspect-ratio: 9/16;
  margin: 0 auto;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.video-preview.reel-format .reel-video-wrapper {
  width: 100%;
  height: 100%;
  background: #000;
}

.clips-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: flex-start;
  margin-top: 16px;
}

.clip-thumbnail {
  flex: 0 0 auto;
  cursor: pointer;
  transition: transform 0.2s ease;
  border-radius: 8px;
  overflow: hidden;
}

.clip-thumbnail:hover {
  transform: translateY(-4px);
}

.clip-thumbnail.selected {
  border: 3px solid #4a90e2;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,0DAA0D;AAC5D;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C,gBAAgB,YAAY,EAAE;AAC9B,iBAAiB,YAAY,EAAE;AAC/B,YAAY,YAAY,EAAE;AAC1B,cAAc,WAAW,EAAE;AAC3B,eAAe,YAAY,EAAE;AAC7B,eAAe,YAAY,EAAE;;AAE7B;EACE,yBAAyB;EACzB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,wDAAwD;EACxD,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;EACxD,eAAe;EACf,cAAc;EACd,6DAA6D;EAC7D,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA,gDAAgD;AAChD;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,4BAA4B;EAC5B,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB,EAAE,uCAAuC;AAC7D;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE;IACE,eAAe;IACf,cAAc;IACd,kBAAkB,EAAE,oCAAoC;EAC1D;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;AACF;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;AAC/C","sourcesContent":[".dashboard-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 20px;\n  overflow-x: visible;\n}\n\n.dashboard-container h1 {\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.dashboard-content {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  overflow-x: visible;\n  gap: 20px;\n}\n\n.jobs-list {\n  margin-bottom: 20px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  padding: 0;\n  overflow: hidden;\n}\n\n.jobs-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 32px;\n  border-bottom: 1px solid #e9ecef;\n  background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);\n}\n\n.jobs-header h2 {\n  margin: 0;\n  color: #2c3e50;\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.auto-refresh-controls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 16px;\n  background: rgba(74, 144, 226, 0.1);\n  border-radius: 8px;\n  border: 1px solid rgba(74, 144, 226, 0.2);\n}\n\n.auto-refresh-controls label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #4a90e2;\n  font-weight: 500;\n}\n\n.refresh-interval {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.refresh-interval input {\n  width: 60px;\n  padding: 4px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 13px;\n}\n\n.refresh-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(74, 144, 226, 0.3);\n}\n\n.refresh-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.4);\n}\n\n.refresh-icon {\n  animation: rotate 2s linear infinite paused;\n}\n\n.refresh-btn:hover .refresh-icon {\n  animation-play-state: running;\n}\n\n@keyframes rotate {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.search-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 32px;\n  border-bottom: 1px solid #e9ecef;\n  background: #f8f9fa;\n}\n\n.search-wrapper {\n  position: relative;\n  flex: 1;\n  max-width: 500px;\n}\n\n.search-input {\n  width: 100%;\n  padding: 12px 20px;\n  border: 2px solid #e9ecef;\n  border-radius: 10px;\n  font-size: 14px;\n  outline: none;\n  transition: all 0.2s ease;\n  background: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.search-input:focus {\n  border-color: #4a90e2;\n  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);\n}\n\n.search-input::placeholder {\n  color: #6c757d;\n}\n\n.clear-search-btn {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #6c757d;\n  cursor: pointer;\n  font-size: 16px;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.clear-search-btn:hover {\n  background-color: #f8f9fa;\n  color: #495057;\n}\n\n.job-count-info {\n  font-size: 14px;\n  color: #6c757d;\n  font-weight: 500;\n  padding: 8px 16px;\n  background: white;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n}\n\n/* Table Container */\n.jobs-table-container {\n  border-radius: 0 0 12px 12px;\n}\n\n.table-wrapper {\n  width: 100%;\n}\n\n.modern-jobs-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  table-layout: fixed;\n}\n\n.modern-jobs-table th {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  color: #495057;\n  font-weight: 600;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 12px 16px;\n  text-align: left;\n  border-bottom: 2px solid #dee2e6;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.modern-jobs-table th:first-child {\n  padding-left: 32px;\n}\n\n.modern-jobs-table th:last-child {\n  padding-right: 32px;\n}\n\n/* Column widths - Updated for 6 columns */\n.col-video-id { width: 260px; }\n.col-file-name { width: 300px; }\n.col-user { width: 180px; }\n.col-status { width: 60px; }\n.col-created { width: 160px; }\n.col-actions { width: 120px; }\n\n.job-row {\n  transition: all 0.2s ease;\n  cursor: pointer;\n  border-bottom: 1px solid #f1f3f4;\n}\n\n.job-row:hover {\n  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.job-row.expanded {\n  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);\n  border-bottom: 2px solid #2196f3;\n}\n\n.job-row td {\n  padding: 12px 16px;\n  vertical-align: middle;\n  border-bottom: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.job-row td:first-child {\n  padding-left: 32px;\n}\n\n.job-row td:last-child {\n  padding-right: 32px;\n}\n\n/* Cell Styles */\n.job-id-badge {\n  display: inline-block;\n  padding: 6px 12px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  min-width: 40px;\n  text-align: center;\n}\n\n.video-id-cell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.video-id-text {\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n  font-size: 12px;\n  color: #2c3e50;\n  background: #f8f9fa;\n  padding: 4px 8px;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.copy-btn {\n  background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);\n  color: white;\n  border: none;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  font-size: 11px;\n  font-weight: 500;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.copy-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(74, 144, 226, 0.3);\n}\n\n.file-info {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.file-details {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.filename {\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n  font-size: 12px;\n  color: #2c3e50;\n  background: linear-gradient(135deg, #e8f5e8 0%, #f0fff0 100%);\n  padding: 4px 8px;\n  border-radius: 4px;\n  border: 1px solid #c3e6c3;\n  display: block;\n  margin-bottom: 2px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.file-source {\n  font-size: 10px;\n  color: #6c757d;\n  font-style: italic;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.user-cell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.user-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 2px solid #e9ecef;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.user-details {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.user-name {\n  font-weight: 500;\n  color: #2c3e50;\n  font-size: 13px;\n  margin-bottom: 2px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.user-email {\n  font-size: 11px;\n  color: #6c757d;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.status-badge.modern {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border: 1px solid transparent;\n}\n\n.status-indicator {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% { opacity: 1; }\n  50% { opacity: 0.5; }\n  100% { opacity: 1; }\n}\n\n.status-completed .status-indicator {\n  background: #28a745;\n  animation: none;\n}\n\n.status-completed {\n  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);\n  color: #155724;\n  border-color: #c3e6cb;\n}\n\n.status-processing .status-indicator {\n  background: #fd7e14;\n}\n\n.status-processing {\n  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);\n  color: #856404;\n  border-color: #ffeaa7;\n}\n\n.status-pending .status-indicator {\n  background: #6f42c1;\n}\n\n.status-pending {\n  background: linear-gradient(135deg, #e2e3f0 0%, #d1ecf1 100%);\n  color: #6f42c1;\n  border-color: #d1ecf1;\n}\n\n.status-failed .status-indicator {\n  background: #dc3545;\n  animation: none;\n}\n\n.status-failed {\n  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);\n  color: #721c24;\n  border-color: #f5c6cb;\n}\n\n/* Status indicator only (color circle) styles */\n.status-indicator-only {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.status-indicator-only:hover {\n  transform: scale(1.2);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.status-indicator-only.status-completed {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  border-color: #28a745;\n}\n\n.status-indicator-only.status-processing {\n  background: linear-gradient(135deg, #ffc107 0%, #fd7e14 100%);\n  border-color: #ffc107;\n  animation: pulse 2s infinite;\n}\n\n.status-indicator-only.status-pending {\n  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);\n  border-color: #6c757d;\n}\n\n.status-indicator-only.status-failed {\n  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);\n  border-color: #dc3545;\n}\n\n/* Open App Button */\n.open-app-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.2);\n}\n\n.open-app-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);\n  background: linear-gradient(135deg, #218838 0%, #1e7e34 100%);\n}\n\n.date-cell {\n  text-align: left;\n}\n\n.date-primary {\n  font-size: 13px;\n  color: #2c3e50;\n  font-weight: 500;\n  margin-bottom: 2px;\n}\n\n.date-secondary {\n  font-size: 11px;\n  color: #6c757d;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 6px;\n  justify-content: center;\n}\n\n.action-btn {\n  background: none;\n  border: 1px solid #e9ecef;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.action-btn:hover {\n  background: #f8f9fa;\n  border-color: #dee2e6;\n  transform: scale(1.1);\n}\n\n.view-btn:hover {\n  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);\n  border-color: #2196f3;\n}\n\n.expand-btn:hover {\n  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);\n  border-color: #ff9800;\n}\n\n.no-data {\n  color: #6c757d;\n  font-style: italic;\n  font-size: 13px;\n}\n\n/* Empty States */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: #6c757d;\n}\n\n.empty-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n  opacity: 0.5;\n}\n\n.empty-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #495057;\n  margin-bottom: 8px;\n}\n\n.empty-subtitle {\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.clear-search-link {\n  background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.clear-search-link:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(74, 144, 226, 0.3);\n}\n\n/* Expanded Row */\n.expanded-row td {\n  padding: 0;\n  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);\n  border-bottom: 2px solid #2196f3;\n}\n\n.expanded-cell {\n  animation: expandRow 0.3s ease-out;\n}\n\n@keyframes expandRow {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.expanded-content {\n  padding: 32px;\n  border-left: 4px solid #2196f3;\n  margin: 0 20px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.expanded-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.expanded-header h3 {\n  margin: 0;\n  font-size: 1.3rem;\n  color: #2c3e50;\n  font-weight: 600;\n}\n\n.close-button {\n  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 8px 16px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.close-button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .col-created, .col-updated {\n    display: none;\n  }\n  \n  .jobs-header {\n    flex-direction: column;\n    gap: 16px;\n    align-items: flex-start;\n  }\n  \n  .search-controls {\n    flex-direction: column;\n    gap: 16px;\n    align-items: stretch;\n  }\n}\n\n@media (max-width: 768px) {\n  .col-file-name, .col-user {\n    display: none;\n  }\n  \n  .jobs-header,\n  .search-controls {\n    padding: 16px 20px;\n  }\n  \n  .job-row td:first-child,\n  .modern-jobs-table th:first-child {\n    padding-left: 20px;\n  }\n  \n  .job-row td:last-child,\n  .modern-jobs-table th:last-child {\n    padding-right: 20px;\n  }\n  \n  .expanded-content {\n    padding: 20px;\n    margin: 0 10px;\n  }\n}\n\n/* Copy Toast Notification */\n.copy-toast {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  z-index: 10000;\n  opacity: 0;\n  transform: translateY(-10px);\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);\n}\n\n.copy-toast.visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* Reel Format Video Styles */\n.reel-format {\n  margin-bottom: 32px;\n}\n\n.reel-video-container {\n  width: 100%;\n  max-width: 600px;\n  margin: 0 auto;\n  background: #000;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  aspect-ratio: 9/16; /* Fixed aspect ratio for reel format */\n}\n\n.reel-video-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background: #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.reel-video {\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  background: #000;\n  display: block;\n}\n\n.original-video-section.reel-format h4,\n.clip-preview-section.reel-format h4 {\n  text-align: center;\n  margin-bottom: 20px;\n  padding: 16px 24px;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.original-download-btn,\n.clip-download-btn {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.original-download-btn:hover,\n.clip-download-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);\n}\n\n.original-download-btn:disabled,\n.clip-download-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.close-preview-btn {\n  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.close-preview-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);\n}\n\n/* Video loading state for reel format */\n.reel-video-wrapper .video-loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: white;\n}\n\n/* Responsive design for reel format */\n@media (max-width: 768px) {\n  .reel-video-container {\n    max-width: 100%;\n    margin: 0 16px;\n    aspect-ratio: 9/16; /* Maintain aspect ratio on mobile */\n  }\n  \n  .reel-video-wrapper {\n    width: 100%;\n    height: 100%;\n  }\n  \n  .original-video-section.reel-format h4,\n  .clip-preview-section.reel-format h4 {\n    flex-direction: column;\n    gap: 12px;\n    padding: 12px 16px;\n  }\n}\n\n/* Clip thumbnail reel format */\n.video-preview.reel-format .reel-video-container {\n  max-width: 200px;\n  width: 200px;\n  aspect-ratio: 9/16;\n  margin: 0 auto;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n}\n\n.video-preview.reel-format .reel-video-wrapper {\n  width: 100%;\n  height: 100%;\n  background: #000;\n}\n\n.clips-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  justify-content: flex-start;\n  margin-top: 16px;\n}\n\n.clip-thumbnail {\n  flex: 0 0 auto;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.clip-thumbnail:hover {\n  transform: translateY(-4px);\n}\n\n.clip-thumbnail.selected {\n  border: 3px solid #4a90e2;\n  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.3);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
